import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { VesselToolbarComponent } from '../vessel-toolbar/vessel-toolbar.component';
import { Certificate, CertificateInfo, Vessel, VesselType, VesselsService, Voyage } from '../../vessels.service';
import { Observable, forkJoin } from 'rxjs';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { DocumentService } from 'src/app/documents/documents.service';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { CrewChangeServices } from '../../crew-change/crew-change.service';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { UserLocalStoreService } from 'src/app/shared/services/user-local-store.service';
import { Versioned } from 'src/app/shared/helpers/versioned';
import { Crew, CrewChange } from 'src/app/generated/services/transportation/crew/crew';
import { CrewServiceSpa } from 'src/app/generated/services/transportation/crew/crewSpa';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';
import { VesselInternalAuditsComponent } from '../vessel-internal-audits/vessel-internal-audits.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-vessel-data-entry',
  templateUrl: './vessel-data-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    RouterModule,
    AgGridModule,
    AuthenticationModule,
    MaterialPdfViewerComponent,
    VesselInternalAuditsComponent
  ]
})
export class VesselDataEntryComponent implements OnInit {
  toolbarComponentType = VesselToolbarComponent;
  toolbarComponent!: VesselToolbarComponent;
  title = new EventEmitter<string>();
  vesselTypes!: Observable<VesselType[]>;
  versionedVessel: Versioned<Vessel> | undefined;
  photo: any;
  volumes: any;
  selectedVoyage!: Voyage ;
  certificates: Certificate[] = [];
  _filteredCertificates : Certificate[] = [];

  get filteredCertificates() {
    return this._filteredCertificates;
  }
  set filteredCertificates(value) {
    this._filteredCertificates = value;
  }

  role!: boolean;
  q88FileId!: string;
  certificateFileId!: string;
  formCFileId!: string;
  organisations!: Organisation[];
  organisationsMap!: Map<string, Organisation>;
  onBoardCrews: Crew[] = [];
  crew: Crew[] = [];
  crewChanges!: CrewChange[];
  master!: string;
  fineCertificates : Certificate[] = [];
  warningCertificates : Certificate[] = [];
  dangerCertificates : Certificate[] = [];
  expiredCertificates : Certificate[] = [];
  crewHistory!: {
    crew: Crew | undefined;
    crewChanges: CrewChange[];
  }[];
  calculateLaytime = VesselsService.calculateLaytime;
  calculateBerthTime = VesselsService.calculateBerthTime;
  voyageLengthFromLoadingToDischarge = VesselsService.voyageLengthFromLoadingToDischarge;

  certificateGridOptions: GridOptions = {};
  crewGridOptions: GridOptions = {};
  gridRestored: boolean = false;

  constructor(private _vesselsService: VesselsService,
    private _crewChangeService: CrewChangeServices,
    private _activateRoute: ActivatedRoute,
    private _keycloakService: KeycloakService,
    private _pgMessagesService: PgMessagesService,
    private _documentsService: DocumentService,
    private _organisationService: OrganisationService,
    private _renderer: Renderer2,
    private _router: Router,
    private _userLocalStorage: UserLocalStoreService,
    private _crewService: CrewServiceSpa,
    private _lookupServiceSpa: LookupServiceSpa
  ) { }

  crewColumnDefs = [
    {
      headerName: 'Name', field: 'lastName',
      cellRenderer: (row:ICellRendererParams) => {
        const crew = `${row.data.firstName} ${row.data.lastName}`;
        return AgGridService.editButtonWithText(
          this._renderer,
          this._router,
          this.navigateToCrew,
          row.data,
          crew);
      },
      filterValueGetter: (params:ICellRendererParams) => `${params.data?.firstName} ${params.data?.lastName}`,
    },
    {
      headerName: 'Rank',
      valueGetter: (row:ICellRendererParams) => this.getLastCrewChange(row.data.crewChanges)!.rank,
      filterValueGetter: (row: ICellRendererParams) => this.getLastCrewChange(row.data.crewChanges)!.rank
    },
    {
      headerName: 'On Board Date',
      field: 'crewChanges',
      valueFormatter: (row: ICellRendererParams) => this.planTime(row.value, 'On Board')
    },
    {
      headerName: 'Duration(Month)',
      field: 'crewChanges',
      cellRenderer: (row: ICellRendererParams) => this.onboardTimeMonthsDays(row.value)
    },
  ];

  crewhistoryColumnDefs = [
    {
      headerName: 'Name',
      field: 'crew.lastName',
      cellRenderer: (row: ICellRendererParams) => {
        const crew = `${row.data.crew.firstName} ${row.data.crew.lastName}`;
        return AgGridService.editButtonWithText(
          this._renderer,
          this._router,
          this.navigateToCrew,
          row.data.crew,
          crew
        );
      },
      filterValueGetter: (params: ICellRendererParams) =>
        `${params.data?.crew?.firstName} ${params.data?.crew?.lastName}`,
    },

    {
      headerName: 'Nationality',
      valueGetter: (row: ICellRendererParams) =>
        this.findOrganisation(row.data.crew.nationality),
    },

    {
      headerName: 'Rank',
      valueGetter: (row: ICellRendererParams) =>
        this.getLastCrewChange(row.data.crewChanges)!.rank,
      filterValueGetter: (row: ICellRendererParams) =>
        this.getLastCrewChange(row.data.crewChanges)!.rank
    },

    {
      headerName: 'Number of assignments',
      valueGetter: (row: ICellRendererParams) =>
        row.data.crewChanges.length
    },

  ];

  certificateColumnDefs = [
    {
      headerName: 'Name', field: 'name',
      cellRenderer: (params:ICellRendererParams) => {
        const certificateName = params.data.name;
        return AgGridService.editButtonWithText(
          this._renderer,
          this._router,
          (_router, data) => this.editCertificate(data),
          params.data,
          certificateName
        );
      }
    },
    {
      headerName: 'Issue Date',
      field: 'info',
      valueFormatter: (row: ICellRendererParams) =>
        DateTimeHelpers.formatLocalDate(row.value.issueDate)
    },
    {
      headerName: 'End Date',
      cellRenderer: (row: ICellRendererParams) =>
        this.changeDateColor(row.data.info)
    },
    {
      headerName: 'Download',
      cellRenderer: (row: ICellRendererParams) =>
        AgGridService.downloadButton(
          this._renderer,
          () => this.downloadDocument(row.data.info.fileId, row.data.name),
        )
    }
  ];

  ngOnInit(): void {
    this.certificateGridOptions = AgGridService.getOptions();
    this.crewGridOptions = AgGridService.getOptions();
    this.master = '';
    this.vesselTypes = this._vesselsService.getVesselTypes();
    this._activateRoute.params.subscribe(params => {
      const imo = params['imo'];
      if (imo) {
        forkJoin([
          this._vesselsService.getVessel(imo),
          this._organisationService.get(),
          this._vesselsService.getVoyagesByIMO(imo),
          this._organisationService.getOrganisationIdToOrganisationMap(),
          this._crewService.getCrewWithOnboardCrewChangeByVesselImo({ vesselImo: imo }),
          this._crewService.getCrewsByVesselImo({ vesselImo: imo })
        ]).subscribe(result => {
          this.versionedVessel = result[0];
          if (this.versionedVessel?.data?.documents.find(d => d.documentType === 'Q88')) {
            const q = this.versionedVessel?.data?.documents.filter(d => d.documentType === 'Q88')
              .sort((a, b) => b.issueDate - a.issueDate);
            this.q88FileId = q[0].documentId;
          }
          this.certificates = this.versionedVessel.data!.certificates;
          this.filteredCertificates = this.certificates;
          this.extractCertificateStatus();
          this.organisations = result[1];
          this.organisationsMap = result[3];
          if (this.versionedVessel?.data?.spec?.photoIds) {
            this._documentsService.download(this.versionedVessel?.data?.spec?.photoIds[length - 1]).subscribe(b => {
              const reader = new FileReader();
              reader.readAsDataURL(b.body);
              reader.onload = () => {
                this.photo = reader.result;
              };
            });
          }
          if (this.versionedVessel?.data?.documents.find(d => d.documentType === 'Form C')) {
            const q = this.versionedVessel?.data?.documents.filter(d => d.documentType === 'Form C')
              .sort((a, b) => b.issueDate - a.issueDate);
            this.formCFileId = q[0].documentId;
          }
          this.title.emit(`${this.versionedVessel?.data?.name?.name}`);
          const sorted = result[2].sort((a, b) => {
            if (b.nors.length > 0 && a.nors.length > 0) {
              return b.nors.filter(n => n.norType === 'loading').sort((n1, n2) => n1.timestamp - n2.timestamp)[0].timestamp -
                a.nors.filter(n => n.norType === 'loading').sort((n1, n2) => n1.timestamp - n2.timestamp)[0].timestamp;
            } else {
              return b.shipVoyageNo.localeCompare(a.shipVoyageNo);
            }
          });
          this.selectedVoyage = sorted[0];
          this.volumes = this.calculateVolumes();
          if (this._keycloakService.hasRole('vessels-crew-viewer')) {
            this.onBoardCrews = result[4].crews.map(c => c.crew!);
            const m = this.onBoardCrews.find(s => this.getLastCrewChange(s.crewChanges)?.rank === 'Master');
            if (m) {
              this.master = `${m.firstName} ${m.lastName}`;
            }
            this.crewHistory = result[5].crews
              .filter(c => c.data)
              .map(c => ({
                crew: c.data!,
                crewChanges: c.data!.crewChanges.filter(
                  ch => ch.vesselImo === imo && !ch.isDeleted && !ch.isCancelled
                )
              }));
          }

        });
      } else {
        this.title.emit('New Vessel');
      }
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  saveGridState(event: GridReadyEvent) {
    AgGridService.saveGridState(event, this.gridRestored, this._userLocalStorage, 'onboardGrid');
  }

  restoreGridState(event: GridReadyEvent) {
    this.gridRestored = AgGridService.restoreGridState(event, this._userLocalStorage, 'onboardGrid');
  }

  editCertificate(data: Certificate) {
    this._router.navigate(['/vessels/certificate', this.versionedVessel?.data?.imo, data.name]);
  }

  addCertificate() {
    this._router.navigate(['/vessels/certificate', this.versionedVessel?.data?.imo]);
  }

  colorCode(date: number) {
    const oneDayThreshold = moment().add(1, 'days').unix() * 1000;
    const oneMonthThreshold = moment().add(1, 'months').unix() * 1000;
    const threeMonthThreshold = moment().add(3, 'months').unix() * 1000;
    return (date < oneDayThreshold) ? 'text-red' :
      (date > oneDayThreshold && date <= oneMonthThreshold) ? 'text-yellow' :
        (date > oneMonthThreshold && date <= threeMonthThreshold) ? 'text-green' :
          (date >= threeMonthThreshold) ? 'text-blue' : '';
  }

  extractCertificateStatus() {
    const oneDayThreshold = moment().add(1, 'days').unix() * 1000;
    const oneMonthThreshold = moment().add(1, 'months').unix() * 1000;
    const threeMonthThreshold = moment().add(3, 'months').unix() * 1000;
    this.expiredCertificates = this.certificates.filter(i => i.info!.expirationDate < oneDayThreshold);
    this.dangerCertificates = this.certificates.filter(i => i.info!.expirationDate > oneDayThreshold && i.info!.expirationDate <= oneMonthThreshold);
    this.warningCertificates = this.certificates.filter(i => i.info!.expirationDate > oneMonthThreshold && i.info!.expirationDate <= threeMonthThreshold);
    this.fineCertificates = this.certificates.filter(i => i.info!.expirationDate >= threeMonthThreshold);
  }

  changeDateColor(certificate: CertificateInfo): string {
    const dateClass = this.colorCode(certificate.expirationDate);
    const text = `${DateTimeHelpers.formatLocalDate(certificate.expirationDate)}`;
    const dateSpan = this._renderer.createElement('span');
    this._renderer.addClass(dateSpan, dateClass);
    this._renderer.appendChild(dateSpan, this._renderer.createText(text));
    return dateSpan;
  }

  findNorLocations(norType: string) {
    const loadingNors = this.selectedVoyage.nors.filter(n => n.norType === norType);
    if (loadingNors && loadingNors.length > 0) {
      return loadingNors.map(n => this.findOrganisation(n.portOrganisationId));
    }
  }

  downloadRender(data: any) {
    return `<a class="btn btn-link text-start" style='text-decoration:none;'>${data}</a>`;
  }

  dateRender(data: number) {
    const cls = this.colorCode(data);
    return `<span class='${cls}'>${this.dateTime(data)}</span>`;
  }

  dateTime(timestamp: number) {
    return DateTimeHelpers.formatLocalDate(timestamp);
  }

  vesselActive() {
    if (this.versionedVessel?.data) {
      this.versionedVessel.data.active = !this.versionedVessel.data.active;
      this._vesselsService.updateVessel(this.versionedVessel).subscribe((r) => {
        this.versionedVessel = r;
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Info,
          topic: 'Vessel',
          message: `The vessel ${this.versionedVessel!.data!.imo} information edited.`
        });
      },
      () => {
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Error,
          topic: 'Vessel',
          message: 'There is a problem to add this vessel.'
        });
      });
    }
  }

  duration(endDate: moment.MomentInput) {
    const now = new Date().getTime();
    return moment(endDate).diff(now, 'days');
  }

  maxlenght(text: string) {
    if (text.length > 20) {
      return text.substring(0, 20) + '...';
    }
    return text;
  }

  downloadDocument(id: string, name: string) {
    this._documentsService.download(id).subscribe(f => {
      saveAs(f.body, `${this.versionedVessel!.data!.name!.name}_${name}.pdf`);
    });
  }

  downloadShipParticular(id: string) {
    this._documentsService.download(id).subscribe(f => {
      saveAs(f.body, `${this.versionedVessel!.data!.name!.name}.xlsx`);
    });
  }

  findOrganisation(organisationId: string) {
    if (this.organisations) {
      const organisation = this.organisationsMap.get(organisationId);
      if (organisation) {
        return organisation.nameTranslations['en'];
      } else {
        return 'not found';
      }
    }
  }

  calculateVolumes() {
    if (this.selectedVoyage) {
      const sumOfRevise = (this.selectedVoyage.billOfLadings) ?
        _.chain(this.selectedVoyage.billOfLadings.filter(bill => bill.revise === true).flatMap(b => b.products))
          .groupBy(b => b.product)
          .map((v, k) => {
            const grossWeight = v.reduce((x, y) => x + y.grossWeight, 0);
            return {
              product: k,
              grossWeight
            };
          }).value() : null;

      const sumOfReal = (this.selectedVoyage.billOfLadings) ?
        _.chain(this.selectedVoyage.billOfLadings.filter(bill => bill.revise !== true).flatMap(b => b.products))
          .groupBy(b => b.product)
          .map((v, k) => {
            const grossWeight = v.reduce((x, y) => x + y.grossWeight, 0);
            return {
              product: k,
              grossWeight
            };
          }).value() : null;

      const dischWeight = (this.selectedVoyage.discharges) ?
        _.chain(this.selectedVoyage.discharges.flatMap(dch => dch.measurements.filter(f => f.primary === true)))
          .groupBy(d => d.product)
          .map((v, k) => {
            const weight = v.reduce((x, y) => x + y.weight, 0);
            return {
              product: k,
              weight
            };
          }).value() : null;

      const productDiffs = (dischWeight && sumOfReal) ?
        dischWeight.map(d => {
          const load = sumOfReal.find(b => b['product'] === d['product']);
          let productDiff = null;
          if (load) {
            productDiff = d['weight'] - load['grossWeight'];
          }
          return {
            product: d['product'],
            diff: productDiff
          };
        }) : null;

      // const totalLoading = sumOfReal.map(p => p.grossWeight).reduce((x, y) => x + y, 0);
      // const totalDischarge = dischWeight.map(p => p.weight).reduce((x, y) => x + y, 0);

      const totalLoading = sumOfReal ? sumOfReal.reduce((total, p) => total + p.grossWeight, 0) : 0;
      const totalDischarge = dischWeight ? dischWeight.reduce((total, p) => total + p.weight, 0) : 0;

      const allDifferences = totalDischarge - totalLoading;
      return {
        loadPorts: this.findNorLocations('loading'),
        dischargePorts: this.findNorLocations('discharging'),
        loadingRealWeight: sumOfReal,
        loadingReviseWeight: sumOfRevise,
        dischargeWeight: dischWeight,
        diff: productDiffs,
        allDiff: allDifferences,
        allLoading: totalLoading,
        allDischarging: totalDischarge,
        noLoadingPorts: this._vesselsService.countPorts(this.selectedVoyage, 'loading'),
        noDischargePorts: this._vesselsService.countPorts(this.selectedVoyage, 'discharge'),
        timeBetweenLoadingDis: this.voyageLengthFromLoadingToDischarge(this.selectedVoyage),
        loadingBerthTime: this.calculateBerthTime(this.selectedVoyage, 'loading'),
        dischargeBerthTime: this.calculateBerthTime(this.selectedVoyage, 'discharge'),
        loadingLaytime: this.calculateLaytime(this.selectedVoyage, 'loading'),
        dischargeLaytime: this.calculateLaytime(this.selectedVoyage, 'discharge')
      };
    }
  }

  downloadFile() {
    this._vesselsService.downloadReportTemplate(this.versionedVessel!.data!.imo).subscribe(b => {
      const n = this.versionedVessel!.data!.name!.name.split(' ').map(s => s.toLowerCase()).join('-');
      saveAs(b.body!, `${n}-${this.versionedVessel?.data?.imo}-report-template.xlsx`);
    }, () => {
      this._pgMessagesService.publishMessage({
        message: 'Could not download report template.',
        level: MessageLevel.Error,
        topic: 'Vessel report template'
      });
    });
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  getLastCrewChange(crewChanges: CrewChange[]) {
    return this._crewChangeService.getLastCrewChange(crewChanges);
  }

  onboardTimeMonthsDays(crewChanges: CrewChange[]) {
    const crewChange = this._crewChangeService.getLastCrewChange(crewChanges);
    return this._crewChangeService.onboardTimeMonthsDays(crewChange!);
  }

  travelTimeDays(crewChange: CrewChange) {
    return this._crewChangeService.travelTimeDays(crewChange);
  }

  planTime(crewChanges: CrewChange[], selectedPlan: string) {
    const crewChange = this._crewChangeService.getLastCrewChange(crewChanges);
    if (this.organisationsMap) {
      return this._crewChangeService.planTime(crewChange!, selectedPlan, this.organisationsMap);
    }
  }

  navigateToCrew(router: Router, crew: Crew) {
    router.navigate(['/vessels/crew-change/crew/profile/', crew.id]).then();
  }
}
